import io from 'socket.io-client';

let socketInstance = null;

/**
 * Returns the shared socket instance, creating it if necessary.
 * Used by components that need real-time chat (e.g. GroupChat).
 */
export function getSocket() {
    if (!socketInstance) {
        const url = process.env.REACT_APP_SOCKET_URL || '';
        socketInstance = io(url);
    }
    return socketInstance;
}

/**
 * Disconnects the socket and clears the reference.
 * Call this on logout so no socket activity continues after the user signs out.
 */
export function disconnectSocket() {
    if (socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
    }
}
